import SchoolIcon from "@mui/icons-material/School";
import { ErasmusServicePath, INTERNSHIP_INCOMING_ERASMUS } from "utils/constants";
import { tenants } from "utils/tenants";
import ListIncomingStudentsIntership from "./List";
import permissions from "app/permissions";
import CreateIncomingIntershipStudent from "./Create";
import ShowIncomingIntershipStudents from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  tenancies: [tenants.MU],
  name: `${ErasmusServicePath}${INTERNSHIP_INCOMING_ERASMUS}`,
  title: "Пристигащи студенти на стаж",
  list: <ListIncomingStudentsIntership />,
  create: <CreateIncomingIntershipStudent />,
  show: <ShowIncomingIntershipStudents />,
  permission: permissions.canPreviewErasmusInternshipStudents,
  createPermission: permissions.canManageErasmusInternshipStudents,
  showPermission: permissions.canPreviewErasmusInternshipStudents,
};
